import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=1b3d93e8&scoped=true"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d93e8",
  null
  
)

export default component.exports